import { render, staticRenderFns } from "./CloseForm.vue?vue&type=template&id=d813d632&scoped=true"
import script from "./CloseForm.vue?vue&type=script&lang=js"
export * from "./CloseForm.vue?vue&type=script&lang=js"
import style0 from "./CloseForm.vue?vue&type=style&index=0&id=d813d632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d813d632",
  null
  
)

export default component.exports